import { Injectable } from '@angular/core';
import {HttpClient } from '@angular/common/http'
import { from, Observable } from 'rxjs';
import { Track } from '../interfaces/track';
import { AngularFireStorage } from '@angular/fire/storage';
import { AngularFireDatabase, AngularFireList, AngularFireObject } from '@angular/fire/database';
import {DataService} from './data.service'
import { ImageTrack } from '../interfaces/image-track';

@Injectable({
  providedIn: 'root'
})
export class TrackingService {
  constructor(
    private http: HttpClient,
    private storage: AngularFireStorage,
    private db: AngularFireDatabase,
    private d:DataService
  ) { }

 sendToken(token:String){
   // return this.http.post<any>("/token_validate", {recaptcha: token})
   //var secretKey = "6LelSZgaAAAAAM1lc6u4pZ_DAuhojE-_xI9E9FsN"
   //var verificationUrl = "https://www.google.com/recaptcha/api/siteverify?secret=" + secretKey + "&response=" +  token + "&remoteip=" + "";
   //return  this.http.get<any>(verificationUrl)
   return token.trim().length > 0
  }

  newTracking(id:string, track:Track){
    return this.db.database.ref(this.d.TRACK_ID).child(id).set(track);
  } 

  newTrackingImage(id:string, image:ImageTrack){
    return this.db.database.ref(this.d.TRACK_IMAGE).child(id).child(new Date().getTime() + "").set(image);
  } 

  listImageTracking(idTrack:string):AngularFireList<ImageTrack>{
    return this.db.list(this.db.database.ref(this.d.TRACK_IMAGE).child(idTrack))
  }

  listTrackingAll():AngularFireList<Track>{
    return this.db.list(this.db.database.ref(this.d.TRACK_ID))
  }

  getTracking(id:string):AngularFireObject<Track>{
    return this.db.object(this.db.database.ref(this.d.TRACK_ID).child(id))
  }

  deleteTracking(id:string){
    return this.db.database.ref(this.d.TRACK_ID).child(id).remove();
  } 

}
